/* eslint-disable consistent-return */
import {
  Avatar,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Tooltip,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { FindInPage, Room } from '@material-ui/icons';
import { Search } from '@material-ui/icons';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import SendIcon from '@material-ui/icons/Send';
import VisibilityIcon from '@material-ui/icons/Visibility';
import {
  connectASchoolPartner,
  getBusinessPartners,
  getTrainingDomains,
  getDegreeLevels,
  getTrainingType,
  getNumberFormationById,
  getSchoolsSearch,
} from '@webapps/business';
import {
  FormikTextField,
  FormikAutocompletePx,
  Loader,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  useAuth,
  useMutation,
  useQuery,
  useRouter,
  useToast,
  PaginationNumbers,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import ConfirmDialog from 'components/ConfirmDialog';
import Row from 'components/Form/Row';
import VerifiedIcon from 'components/Icons/VerifiedIcon';
import { ROUTES_PATH } from 'config/constants';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

import AddPartnerCard from './AddPartnerCard';

const searchSchema = yup.object().shape({
  keyword: yup.string(),
});

const LightTooltip = withStyles(({ shadows }) => ({
  tooltip: {
    backgroundColor: '#5D75A8',
    color: '#FFF',
    boxShadow: shadows[1],
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' },
    '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 600,
  },
}))(Tooltip);

const AddPartner = ({ refetch }) => {
  const {
    css,
    global,
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(3);

  const [keywordRequest, setKeywordRequest] = useState('');
  const [trainingDomainsRequest, setTrainingDomainsRequest] = useState('');
  const [degreeLevelsRequest, setDegreeLevelsRequest] = useState('');
  const [trainingTypesRequest, setTrainingTypesRequest] = useState('');
  const [errorExist, setErrorExist] = useState(false);

  const [idSelect, setIdSelect] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleOpenConfirmDialog = (id) => {
    setIdSelect(id);
    setOpenConfirm(true);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirm(false);
  };

  const {
    status: load,
    data: { content: schools = [], totalElements } = {},
    refetch: refetchSchools,
    isFetching,
    isLoading,
  } = useQuery(getSchoolsSearch, {
    key: ['searchSchoolForPartner', keywordRequest + trainingDomainsRequest + degreeLevelsRequest + trainingTypesRequest + idUser + page],
    variables: {
      keyword: keywordRequest,
      trainingDomains: trainingDomainsRequest,
      degreeLevels: degreeLevelsRequest,
      trainingTypes: trainingTypesRequest,
      businessId: idUser,
      page: page - 1,
      size,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    isLoading: isLoadingConnect,
    isSuccess: isSuccessConnect,
    mutateAsync: mutateConnect,
  } = useMutation(connectASchoolPartner);

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const { push } = useRouter();
  const { addToast } = useToast();

  useEffect(() => {
    if (isSuccessConnect) {
      addToast({
        status: 'success',
        message: 'Demande envoyée',
      });
      handleCloseConfirmDialog();
      refetch();
      refetchSchools();
      formik.resetForm();
    }
  }, [isSuccessConnect]);

  const formik = useFormik({
    initialValues: {
      keyword: '',
      trainingDomains: [],
      degreeLevels: [],
      trainingTypes: [], 
    },
    validationSchema: searchSchema,
    onSubmit: ({ keyword }) => {
      setKeywordRequest(keyword);
      setTrainingDomainsRequest(formik.values?.trainingDomains?.map((value) => value).join());
      setDegreeLevelsRequest(formik.values?.degreeLevels?.map((value) => value).join());
      setTrainingTypesRequest(formik.values?.trainingTypes?.map((value) => value).join());
      setPage(1);
    },
  });

  const viewPartner = (id) => {
    push(ROUTES_PATH.SCHOOL_VITRINE, { params: { id } });
  };

  const { data: { content: mypartnersAccepted = [] } = {} } = useQuery(
    getBusinessPartners,
    {
      key: ['businessPartnersAccepted', page],
      variables: {
        id: idUser,
        type: 'accepted',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: mypartnersReceived = [] } = {} } = useQuery(
    getBusinessPartners,
    {
      key: ['businessPartnersReceived', page],
      variables: {
        id: idUser,
        type: 'received',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: mypartnersRequested = [] } = {} } = useQuery(
    getBusinessPartners,
    {
      key: ['businessPartnersRequested', page],
      variables: {
        id: idUser,
        type: 'requested',
        page: page - 1,
        size: 1000,
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: { content: trainingDomains = [] } = {} } = useQuery(getTrainingDomains,{
    key: 'allTrainingDomains',
  });

  const { data: degreeLevels = [] } = useQuery(getDegreeLevels, {
    key: 'allDegreeLevels',
  });

  const { data: trainingTypes = [] } = useQuery(getTrainingType, {
    key: 'allTrainingTypes',
  });


  const reqPartner = async (id) => {
    const allPartners = [
      ...mypartnersAccepted,
      ...mypartnersReceived,
      ...mypartnersRequested,
    ];
    if (
      allPartners.filter(({ id: idPartnerExist }) => idPartnerExist === id) <= 0
    ) {
      setErrorExist(false);
      await mutateConnect({
        data: {
          schoolId: id,
          businessId: idUser,
        },
      });
    } else {
      handleCloseConfirmDialog();
      refetch();
      refetchSchools();
      formik.resetForm();
      setErrorExist(true);
    }
  };

  useEffect(() => {
    if (formik.values) {
      formik.handleSubmit();
    }
  } , [formik.values]);

  return (
    <div>
      <Grid
        container
        className={css({
          marginBottom: 24,
          columnGap: 10,
          '@media screen and (max-width: 1023px)': {
            flexDirection: 'column',
            rowGap: 10,
          },
        })}
      >
        <Grid item xs>
          <FormikTextField
            formik={formik}
            fullWidth
            label={<FormattedMessage id="partner.searchLabelSchool" />}
            name="keyword"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <Search style={{ color: '#5D75A8' }} />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
        <Grid item xs>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Domaines d'études"
            multiple
            name="trainingDomains"
            options={trainingDomains}
            pathValue="id"
            value={trainingDomains?.filter(({ id }) =>
              formik?.values?.trainingDomains?.includes(id)
            )}
          />
        </Grid>
        <Grid item xs>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Niveau d'étude"
            multiple
            name="degreeLevels"
            options={degreeLevels}
            pathValue="id"
            value={degreeLevels?.filter(({ id }) =>
              formik?.values?.degreeLevels?.includes(id)
            )}
          />
        </Grid>
        <Grid item xs>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            getOptionLabel={(option) => option.label || ''}
            label="Type de formation"
            multiple
            name="trainingTypes"
            options={trainingTypes}
            pathValue="id"
            value={trainingTypes?.filter(({ id }) =>
              formik?.values?.trainingTypes?.includes(id)
            )}
          />
        </Grid>
      </Grid>
      {errorExist && (
        <div className={css({ color: 'red', textAlign: 'center' })}>
          Vous êtes déjà partenaire avec cet organisme ou en attente de
          validation
        </div>
      )}
      <Grid
        className={classes.PartenerCardContainer}
        container
        spacing={3}
        style={{
          backgroundColor: '#F3F7FF',
          borderRadius: 20,
          padding: 8,
          rowGap: 20,
          marginBottom: spacing(2.5),
          position: 'relative',
        }}
      > 
      {isFetching && (
        <div className={global.loader}>
          <Loader />
        </div>
      )}
        {schools?.map(({ account, address, id, name }) => (
          <AddPartnerCard
            account={account}
            address={address}
            id={id}
            name={name}
            handleOpenConfirmDialog={handleOpenConfirmDialog}
          />
        ))}
      </Grid>
      <PaginationNumbers
        onChange={handlePaginationChange}
        page={page}
        pageCount={size}
        totalCount={totalElements}
      />
      <ConfirmDialog
        confirm={() => reqPartner(idSelect)}
        handleCloseConfirmDialog={handleCloseConfirmDialog}
        isLoadingConfirm={isLoadingConnect}
        openConfirm={openConfirm}
        title="Confirmez-vous ?"
      ></ConfirmDialog>
    </div>
  );
};

AddPartner.propTypes = {
  refetch: PropTypes.func,
};

const styles = ({ spacing }) => ({
  cardContainer: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(2),
    paddingRight: spacing(2),
    height: '100%',
    padding: 20,
  },
  PartenerCardContainer: {
    margin: 0,
    width: '100%',
    '@media screen and (max-width: 768px)': {
      flexDirection: 'column',
    },
  },
  nameAdressDiv: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 10,
  },
  avatar: {
    height: 80,
    width: 80,
  },
});

export default AddPartner;
